import { render, staticRenderFns } from "./VouchersTableHistory.vue?vue&type=template&id=c580e9a0&scoped=true"
import script from "./VouchersTableHistory.vue?vue&type=script&lang=js"
export * from "./VouchersTableHistory.vue?vue&type=script&lang=js"
import style0 from "./VouchersTableHistory.vue?vue&type=style&index=0&id=c580e9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c580e9a0",
  null
  
)

export default component.exports